"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Card_styled_exports = {};
__export(Card_styled_exports, {
  StyledCard: () => StyledCard
});
module.exports = __toCommonJS(Card_styled_exports);
var import_mixins = require("../../../themes/mixins");
var import_styled_components = __toESM(require("styled-components"));
var StyledCard = import_styled_components.default.div.withConfig({
  displayName: "Cardstyled__StyledCard",
  componentId: "sc-1r1fsxk-0"
})(function(_ref) {
  var theme = _ref.theme, type = _ref.type, _ref$width = _ref.width, width = _ref$width === void 0 ? "240px" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "160px" : _ref$height;
  return (0, import_styled_components.css)(["box-sizing:border-box;display:flex;font-family:", ";border-radius:4px;", ";width:", ";height:", ";background-color:", ";box-shadow:0px 0px 0px 1px ", ";", ""], theme.typography.fonts.primary, (0, import_mixins.withPadding)("medium"), width, height, theme.colors.white, theme.colors.beige["180"], type === "interactive" && (0, import_styled_components.css)(["&:focus,&:focus-visible{outline:none;box-shadow:", " 0px 0px 0px 1px,", " 0px 0px 0px 2px,", " 0px 0px 0px 3px;}&:hover{box-shadow:0px 0px 0px 2px ", ";}&:active{background-color:", ";box-shadow:0px 0px 0px 1px ", ";}"], theme.colors.beige[180], theme.colors.white, theme.colors.beige[180], theme.colors.n["100"], theme.colors.beige[60], theme.colors.beige["180"]));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledCard
});
//# sourceMappingURL=Card.styled.js.map